import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable, Subject, timer } from 'rxjs';
import { map, shareReplay, takeUntil, switchMap } from 'rxjs/operators';
import {AppSettings} from '../common/app.settings';
import {BaseService} from './base.service'
import {UsersModel} from '../models/dashboard.model'
@Injectable()
export class ProfileService extends BaseService{
    private cache$: Observable<any>;
    private reload$ = new Subject<void>();

    constructor(http: HttpClient) {
        super(http);        
    }
    get usersList() {//Dashboard data will be refreshed every 10 minutes
      if (!this.cache$) {
        const timer$ = timer(0, AppSettings.CACHE_REFRESH_INTERVAL);
      this.cache$ = timer$.pipe(
        switchMap(() => this.getUsersList()),
        takeUntil(this.reload$),
        shareReplay(1)
      );
        }
     return this.cache$;
      }
      getUsersList() {
            // get dashboard data from api
            return this.http.get(`${AppSettings.API_ENDPOINT}${AppSettings.VV_USERS_LIST_EP}`)
                .pipe(map((response: Response) => response));
    }
    clearCache() {
        // Calling next will complete the current cache instance
        this.reload$.next();    
        this.cache$ = null;
      }
      saveUser(userModel: UsersModel,operation:string): Observable<Object> {
        var params = JSON.stringify(userModel);
        var re = new RegExp("environments", 'g');
        params = params.replace(re, "envs")
        var endpoint = AppSettings.VV_USERS_SAVE_EP;
        if(operation == 'adduser')
          endpoint=AppSettings.VV_USERS_ADD_EP;
        return this.http
          .post(`${AppSettings.API_ENDPOINT}${endpoint}`, params)
          .pipe(map((response: Response) => {
            return response;
          }));
      }
}